
export const getSnapStrategy = 'snapStrategy/getSnapStrategy';
export const createSnapStra = 'snapStrategy/createSnapStra';
export const modifyStrategy = 'snapStrategy/modifyStrategy';
export const validateSnapStra = 'snapStrategy/validateSnapStra';
export const validateEbsAndLocalSnapStra= 'snapStrategy/validateEbsAndLocalSnapStra'
export const deleteStrategy = 'snapStrategy/deleteStrategy';
export const applyStrategy = 'snapStrategy/applyStrategy';
export const cancelStrategy = 'snapStrategy/cancelStrategy';
export const bindStrategy = 'snapStrategy/bindStrategy';
export const getnextSnapTime = 'snapStrategy/getnextSnapTime';
export const GetAutoSnapshotQuota = 'snapStrategy/GetAutoSnapshotQuota';
export const QuerySnapshotCopyRegionLimits = 'snapStrategy/QuerySnapshotCopyRegionLimits';
export const describePolicyVolumes = 'snapStrategy/describePolicyVolumes';
export const uniqRequestRegion = 'snapStrategy/uniqRequestRegion';
